import { render, staticRenderFns } from "./diagnosticInfo.vue?vue&type=template&id=d9bcfb36"
import script from "./diagnosticInfo.vue?vue&type=script&lang=js"
export * from "./diagnosticInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports